import React from 'react'

export const TeamIconProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [shouldLoadDefaultIcon, setShouldLoadDefaultIcon] = React.useState(false)
  return (
    <TeamIconContext.Provider
      value={{
        shouldLoadDefaultIcon,
        setShouldLoadDefaultIcon: (value: boolean) => setShouldLoadDefaultIcon(value),
      }}
    >
      {children}
    </TeamIconContext.Provider>
  )
}

export const TeamIconContext = React.createContext<{
  shouldLoadDefaultIcon: boolean | null
  setShouldLoadDefaultIcon: (value: boolean) => void
}>({
  shouldLoadDefaultIcon: true,
  setShouldLoadDefaultIcon: () => null,
})
